import {matchSorter} from "match-sorter";

const fuzzyTextFilter = (rows: any[], id: number, filterValue: string) => {
    console.log('fuzzy searchfilter')
    return matchSorter(rows, filterValue, { keys: [row => row.values[id]] });
}
fuzzyTextFilter.autoRemove = (val: Boolean) => !val
export default fuzzyTextFilter